import { VssAuthService } from 'projects/vss-ui/src/public-api';
import { Component, OnInit } from "@angular/core";
import { environment } from "@appEnv/environment";
import { HttpClient } from "@angular/common/http";
import { VtSSOService } from "../../../projects/vss-ui/src/vss-ui/services/auth/vt-sso.service";
import { Router } from "@angular/router";
import { NzMessageService } from 'ng-zorro-antd/message';
import { AuthService } from '@app/service/auth.service';
import { PATH, PATH2 } from '@app/modules/shares/enum/constants'

@Component({
  selector: 'vt-sso-validate-ticket',
  template: ``,
  styles: []
})
export class VtSsoValidateTicketComponent implements OnInit {
  constructor(private http: HttpClient,
    private router: Router,
    private vssAuthService: VssAuthService,
    private message: NzMessageService,
    private authService: AuthService) {
  }

  ngOnInit(): void {
    const callbackUrl = localStorage.getItem(VtSSOService.callbackUrlKey);
    const urlParams = new URLSearchParams(window.location.search);
    const ticketId = urlParams.get(VtSSOService.requestParamTicketKey);
    let href = window.location.href.split('?')[0];
    if (window.location.pathname !== '/') {
      href = href.replaceAll(window.location.pathname, '/');
    }
//     const vtSsoValidateTicketUrl = environment.vtSso.serviceValidate + `/api/sso/p3/serviceValidate?service=${href}&ticket=${ticketId}`;
//     this.http.get(vtSsoValidateTicketUrl, { responseType: 'text' }).toPromise()
//       .then(cas => {
//         cas = cas.split('\n').map(l => l.trim()).join('').replace('\n', '').replace('\r', '');
//         const authTokenUrl = environment.apiUrl + PATH2 + '/api/auth/token?cas=' + encodeURIComponent(cas);
        const authTokenUrl = environment.apiUrl + '/api/auth/login-sso';
//         this.http.get(authTokenUrl, { responseType: 'json' }).toPromise()
        this.http.post(authTokenUrl, {'service': href, 'ticket': ticketId}, { responseType: 'json' }).toPromise()
          .then((authentication: any) => {
//             const authenFailure = JSON.parse(JSON.stringify(authentication))?.authenticationFailure;
//             if (authenFailure) {
//               this.message.error(authenFailure?.description)
//               this.vssAuthService.logout()
//             } else {
              // this.authService.initFailLoginCount();
              localStorage.setItem('sso', '1')
              localStorage.setItem('menuItems', JSON.stringify(authentication?.data?.menuItems))
              localStorage.setItem('roles', JSON.stringify(authentication?.data?.roles))
              authentication.data.token = authentication?.data?.accessToken
              localStorage.setItem(VtSSOService.requestParamTicketKey, JSON.stringify(authentication.data));
              // if (this.authService.isAdministrator())
              //   this.router.navigateByUrl('/codev/admin/user-management');
              // else
              //   this.router.navigateByUrl('/codev/user/organization-membership');
              this.router.navigateByUrl('/');
//             }
          })
          .catch(error => {
            console.error('Validation failed:', error);
            this.message.error("Login SSO failed")
            this.vssAuthService.logout()
            // setTimeout(() => this.router.navigate([callbackUrl]).then(), 500);
            // setTimeout(() => this.router.navigate([callbackUrl?.includes('/validate-ticket') ? '/' : callbackUrl]).then(), 500);
          });
//       })
//       .catch(error => {
//         console.error('Validation failed:', error);
//         this.message.error("Login SSO failed")
//         this.vssAuthService.logout()
//         // setTimeout(() => this.router.navigate([callbackUrl]).then(), 500);
//       });
  }

}
